<div class="radial-chart">
	<div class="radial-chart__canvas">
		<canvas #chartCanvas [attr.id]="canvasId"></canvas>
	</div>
	<div class="radial-chart__legend" *ngIf="legendItems.length">
		<div class="legend-item" *ngFor="let item of legendItems; trackBy: trackByLegend">
			<span class="legend-dot" [style.background]="item.color"></span>
			<span class="legend-label">{{ item.label }} </span>
		</div>
	</div>
</div>
